import { PssApiTags, pssApiSlicev1 } from "../../../configs/_pss.apis.v1";
import { LogoModel } from "../../../types/models/logo.model";
import LogoUpsertFormParam from "../../../types/params/logo-upsert-form.param";

export const pssLogoPictureApiSlice = pssApiSlicev1.injectEndpoints({
  endpoints: (builder) => ({
    apiPssLogo: builder.query<LogoModel, string | undefined>({
      query: (id) => ({
        url: `/logo/${id}/corporate-picture?logo=true`,
        method: "GET",
      }),
      providesTags: [PssApiTags.LogoWithRelation],
    }),
    apiPssLogoSubmit: builder.mutation<LogoModel, LogoUpsertFormParam>({
      query: ({ logoPicture }) => {
        const formData = new FormData();
        if (logoPicture) formData.append("logoPicture", logoPicture);
        formData.append("company", JSON.stringify(logoPicture));
        return {
          url: "aprs/logo",
          method: "PATCH",
          body: formData,
        };
      },
      invalidatesTags: [PssApiTags.LogoWithRelation],
    }),
    apiPssLogoAdd: builder.mutation<LogoModel, FormData>({
      query: (data) => {
        return {
          url: `/aprs/logo`,
          body: data,
          method: "POST",
        };
      },
      invalidatesTags: [PssApiTags.LogoWithRelation],
    }),
    // apiPssLogoInsigniaDownload: builder.query<
    //   string,
    //   string | null | undefined
    // >({
    //   query: (id) => ({
    //     url: `/logo/${id}/insignia`,
    //     method: "GET",
    //     responseType: "blob",
    //     responseHandler: async (response) =>
    //       URL.createObjectURL(await response.blob()),
    //   }),
    //   providesTags: [PssApiTags.LogoWithRelation],
    // }),
  }),
});

// Real Data (uncomment to use real data and comment out the mock data below it)
export const {
  useApiPssLogoSubmitMutation: useApiPssLogoPicture,
  // useApiPssLogoInsigniaDownloadQuery: useApiPssLogoInsigniaDownload,
  useApiPssLogoQuery: useApiPssLogo,
  useApiPssLogoAddMutation: useApiPssLogoAdd,
} = pssLogoPictureApiSlice;
